/* eslint-disable react-hooks/exhaustive-deps */
import TabNav from "components/TabNav";
import { useCallback, useEffect, useState } from "react";

import ConfirmationModal from "components/ConfirmationModal";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useHasRole } from "contexts/AuthContext";
import { useParams } from "react-router-dom";
import { useTranslation } from "contexts/i18nContext";
import {
  editAppeal,
  editComplaint,
  fetchAdminUnitDetail,
  fetchAdvocateComplaintById,
  fetchAppealByComplaintId,
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchCouncilLitigationBySummonId,
  fetchInvestigationByComplaintId,
  fetchSummonByAppealId,
  fetchSummonByInvestigationId,
} from "services/advocateComplaintService";
import {
  AdminUnit,
  AdvocateComplaints,
  Appeal,
  Complaints,
  CouncilLitigation,
  Investigation,
  Litigation,
  Summon,
} from "types";
import {
  ADVOCATE_APPEAL_STATUS,
  APPEAL_STATUS,
  APPEAL_TYPE,
  COMPLIANT_STATUS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ADVOCATE_ROLES, ROLES } from "utils/roles";
import AppealCard from "../advocateComplaint/fragments/AppealCard";
import ChargeDocumentCard from "../advocateComplaint/fragments/ChargeDocumentCard";
import ComplaintDetailInfoCard from "../advocateComplaint/fragments/ComplaintDetailInfoCard";
import DecisionCard from "../advocateComplaint/fragments/DecisionCard";
import ListEvidenceCard from "../advocateComplaint/fragments/ListEvidenceCard";
import ListReporterCard from "../advocateComplaint/fragments/ListReporterCard";
import ListVictimCard from "../advocateComplaint/fragments/ListVictimCard";
import ListWitnessCard from "../advocateComplaint/fragments/ListWitnessCard";
import AddAppealCouncilLitigationDecisionModal from "./fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealDailyHearingModal from "./fragments/AddAppealDailyHearingModal";
import AddAppealLitigationDecisionModal from "./fragments/AddAppealLitigationDecisionModal";
import AddAppealSummonModal from "./fragments/AddAppealSummonModal";
import AddAppealToCourtModal from "./fragments/AddAppealToCourtModal";
import AppealCouncilLitigationCard from "./fragments/AppealCouncilLitigationCard";
import AppealLitigationCard from "./fragments/AppealLitigationCard";
import AppealSummonCard from "./fragments/AppealSummonCard";
import SummonConfirmationStatus from "./fragments/SummonConfirmationStatus";

export default function SingleAdvocateAppealForRegional() {
  const { uu_id } = useParams();
  const { user } = useAuth();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const canCreateAppealSummon = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  // const canSendInvestigationToCouncil = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  //   ADVOCATE_ROLES.INSPECTION_COORDINATOR,
  // ]);
  const canCreateInspectionDailyHearing = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateCouncilDailyHearing = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  // const canTerminateInspectionLitigation = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  // ]);
  // const canTerminateCouncilLitigation = useHasRole([
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
  //   ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  // ]);
  const canCreateLitigationDecision = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateCouncilLitigationDecision = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  const canViewCompliantDetail = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewSummonConfirmation = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);
  // const canRequestAppeal = useHasRole([ADVOCATE_ROLES.INSPECTION_PROSECUTOR]);
  const canViewChargeDoc = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canViewCourtAppeal = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canSendAppealToRegistrar = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canSendAppealToCouncil = useHasRole([
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canAppealToCourt = useHasRole([ADVOCATE_ROLES.INSPECTION_PROSECUTOR]);
  // const canViewAppealLitigationCard = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  //   ADVOCATE_ROLES.INSPECTION_COORDINATOR,
  // ]);

  const [complaintData, setComplaintData] = useState<
    AdvocateComplaints | AdvocateComplaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [summonData, setSummonData] = useState<Summon>();
  // const [litigationData, setLitigationData] = useState<Litigation[]>();
  const [councilLitigationData, setCouncilLitigationData] =
    useState<CouncilLitigation[]>();

  // const [appealData, setAppealData] = useState<Appeal[]>();
  const [councilAppealData, setCouncilAppealData] = useState<Appeal[]>();
  const [courtAppealData, setCourtAppealData] = useState<Appeal[]>();
  const [appealSummonData, setAppealSummonData] = useState<Summon>();
  const [courtAppealSummonData, setCourtAppealSummonData] = useState<Summon>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [courtAppealLitigationData, setCourtAppealLitigationData] =
    useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();
  const [
    courtAppealCouncilLitigationData,
    setCourtAppealCouncilLitigationData,
  ] = useState<CouncilLitigation[]>();

  // const [isSummonOpen, setIsSummonOpen] = useState(false);
  const [isAppealSummonOpen, setIsAppealSummonOpen] = useState(false);
  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isRejectAppealOpen, setIsRejectAppealOpen] = useState(false);
  // const [isAppealFormOpen, setIsAppealFormOpen] = useState(false);
  // const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [isSendToCouncilModal, setIsSendToCouncilModal] =
    useState<boolean>(false);
  const [isSendToRegistrarModal, setIsSendToRegistrarModal] =
    useState<boolean>(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  // Accordion state for sidebar sections
  type SectionKey = "evidence" | "reporter" | "victim" | "witness";
  const [accordionOpen, setAccordionOpen] = useState<
    Record<SectionKey, boolean>
  >({
    evidence: false,
    reporter: false,
    victim: false,
    witness: false,
  });

  const toggleSection = (key: SectionKey) =>
    setAccordionOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");

  const [adminUnitData, setAdminUnitData] = useState<AdminUnit>();

  useEffect(() => {
    const loadAdminUnitDetail = async () => {
      try {
        const adminUnitDetail = await fetchAdminUnitDetail(
          user?.admin_unit,
          user?.access,
        );
        setAdminUnitData(adminUnitDetail);

        // setError("");
      } catch (err) {
        // setError("Failed to Admin Unit Detail");
      } finally {
        // setLoading(false);
      }
    };
    loadAdminUnitDetail();
  }, [user]);

  const tabs = [
    t("detailInformation"),
    (councilAppealData?.length ?? 0) > 0 && t("councilAppeal"),
    ((appealCouncilLitigationData?.length ?? 0) > 0 ||
      (appealLitigationData?.length ?? 0) > 0) &&
      t("councilAppealLitigation"),
    (courtAppealData?.length ?? 0) > 0 && t("courtAppeal"),
    (courtAppealData?.length ?? 0) > 0 &&
      // courtAppealData![0]?.appeal_status ==
      //   APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
      courtAppealData![0]?.registration_number &&
      t("courtAppealLitigation"),
  ].filter((tab): tab is string => Boolean(tab));

  const [activeTab, setActiveTab] = useState<string>(tabs[0]);

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAdvocateComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadSummon = useCallback(async () => {
    if (!investigationData) return;
    // setLoading(true);
    try {
      const resData = await fetchSummonByInvestigationId(
        investigationData?.uu_id || "",
      );
      if (resData)
        setSummonData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [investigationData]);

  // const loadLitigation = useCallback(async () => {
  //   if (!complaintData || !summonData) return;
  //   setLoading(true);
  //   try {
  //     const resData = await fetchLitigationBySummonId(uu_id || "");
  //     if (resData) setLitigationData(resData?.slice()?.reverse());
  //    // setError("");
  //   } catch (err) {
  //    // setError("Failed to load summon.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [complaintData, summonData]);

  const loadCouncilLitigation = useCallback(async () => {
    if (!summonData) return;
    // setLoading(true);
    try {
      const resData = await fetchCouncilLitigationBySummonId(
        summonData?.id || "",
      );
      if (resData) setCouncilLitigationData(resData?.slice()?.reverse());
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [summonData]);

  const loadAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealByComplaintId(uu_id);
      if (resData) {
        // setAppealData(resData?.slice()?.reverse());
        setCouncilAppealData(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter(
              (obj) =>
                obj.appeal_type ===
                APPEAL_TYPE.INSPECTION_PROSECUTOR_TO_COUNCIL_OFFICE,
            ),
        );
        setCourtAppealData(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter(
              (obj) =>
                obj.appeal_type === APPEAL_TYPE.ACCUSED_PROSECUTOR_TO_COURT,
            ),
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAppealSummon = useCallback(async () => {
    if (!councilAppealData || councilAppealData.length === 0) return;
    if (!councilAppealData[0]?.id) return;

    // setLoading(true);

    try {
      const resData = await fetchSummonByAppealId(
        councilAppealData[0]?.id || "",
      );
      if (resData)
        setAppealSummonData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [councilAppealData]);

  const loadCourtAppealSummon = useCallback(async () => {
    if (!courtAppealData && !Array.isArray(courtAppealData)) return;
    if (!courtAppealData[0]?.id) return;
    // setLoading(true);

    try {
      const resData = await fetchSummonByAppealId(courtAppealData[0]?.id || "");
      if (resData)
        setCourtAppealSummonData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      //// setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealData]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !appealSummonData) return;

    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.summon === appealSummonData?.id),
        );

      //// setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, appealSummonData]);

  const loadCourtAppealLitigation = useCallback(async () => {
    if (!complaintData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setCourtAppealLitigationData(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter((obj) =>
              courtAppealData && courtAppealData?.length > 0
                ? obj.appeal_request === courtAppealData![0]?.id
                : null,
            ),
        );

      //// setError("");
    } catch (err) {
      //// setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, courtAppealData]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!appealSummonData) return;

    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        appealSummonData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.summon === appealSummonData?.id),
        );
      //// setError("");
    } catch (err) {
      //// setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [appealSummonData]);

  const loadCourtAppealCouncilLitigation = useCallback(async () => {
    if (!courtAppealSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        courtAppealSummonData?.id || "",
      );
      if (resData)
        setCourtAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.summon === courtAppealSummonData?.id),
        );
      //// setError("");
    } catch (err) {
      //// setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealSummonData]);

  useEffect(() => {
    loadComplaints();
  }, [uu_id]);

  useEffect(() => {
    loadInvestigations();
  }, [complaintData]);

  useEffect(() => {
    loadSummon();
  }, [investigationData]);

  useEffect(() => {
    // loadLitigation();
  }, [complaintData, summonData]);

  useEffect(() => {
    loadCouncilLitigation();
  }, [complaintData, summonData]);

  useEffect(() => {
    loadAppeal();
  }, [complaintData, councilLitigationData]);

  useEffect(() => {
    councilAppealData && loadAppealSummon();
  }, [councilAppealData]);

  useEffect(() => {
    courtAppealData && loadCourtAppealSummon();
  }, [courtAppealData]);

  useEffect(() => {
    loadAppealLitigation();
  }, [complaintData, appealSummonData]);

  useEffect(() => {
    loadCourtAppealLitigation();
  }, [complaintData, courtAppealData]);

  useEffect(() => {
    complaintData && appealSummonData && loadAppealCouncilLitigation();
  }, [complaintData, appealSummonData]);

  useEffect(() => {
    loadCourtAppealCouncilLitigation();
  }, [complaintData, courtAppealSummonData]);

  const handleSendToRegistrarConfirm = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_feedback_status: councilAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_REGISTRAR,

      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsSendToRegistrarModal(false);
      showToast(t("forwardedToRegistrar"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtSendToRegistrarConfirm = async () => {
    if (!courtAppealData || courtAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: courtAppealData[0]?.appeal_type,
      memorandum_summary: courtAppealData[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealData[0]?.requesting_prosecutor,
      discipline_case: courtAppealData[0]?.discipline_case || null,
      appeal_feedback_status: courtAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_REGISTRAR,

      userid_requesting_prosecutor:
        courtAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = courtAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsSendToRegistrarModal(false);
      showToast(t("forwardedToRegistrar"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleSendToCouncilConfirm = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);

    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_feedback_status: councilAppealData[0]?.appeal_feedback_status,
      appeal_status: councilAppealData[0]?.is_appeal_to_general_council
        ? ADVOCATE_APPEAL_STATUS.FORWARD_TO_COUNCIL_HEAD
        : APPEAL_STATUS.FORWARDED_TO_COUNCIL_WRITER,

      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: adminUnitData?.parent_unit
        ? adminUnitData?.parent_unit
        : !Array.isArray(complaintData)
          ? complaintData?.admin_unit_id
          : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_councileappeal: true,
          admin_unit_id: adminUnitData?.parent_unit
            ? adminUnitData?.parent_unit
            : !Array.isArray(complaintData)
              ? complaintData?.admin_unit_id
              : "",
        });
      }

      loadAppeal();
      setIsSendToCouncilModal(false);
      showToast(t("forwardedToCouncil"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtSendToCouncilConfirm = async () => {
    if (!courtAppealData || courtAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: courtAppealData[0]?.appeal_type,
      memorandum_summary: courtAppealData[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealData[0]?.requesting_prosecutor,
      discipline_case: courtAppealData[0]?.discipline_case || null,
      appeal_feedback_status: courtAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_COUNCIL,

      userid_requesting_prosecutor:
        courtAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = courtAppealData[0]?.id || "";
    const isFormData = false;

    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_appeal: true,
          has_councileappeal: true,
        });
      }

      loadAppeal();
      setIsSendToCouncilModal(false);
      showToast(t("forwardedToCouncil"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleRejectAppeal = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);
    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_status: APPEAL_STATUS.REJECTED,

      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsRejectAppealOpen(false);
      showToast(t("successfullyCreated"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtRejectAppeal = async () => {
    if (!courtAppealData || courtAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);
    const data = {
      appeal_type: courtAppealData[0]?.appeal_type,
      memorandum_summary: courtAppealData[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealData[0]?.requesting_prosecutor,
      discipline_case: courtAppealData[0]?.discipline_case || null,
      appeal_status: APPEAL_STATUS.REJECTED,

      userid_requesting_prosecutor:
        courtAppealData[0]?.userid_requesting_prosecutor,
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id : "",
      accused_advocate_name: !Array.isArray(complaintData)
        ? complaintData?.accused_name
        : "",
      user_id_accused_advocate: !Array.isArray(complaintData)
        ? complaintData?.userid_accused_name
        : "",
      accused_license_number: !Array.isArray(complaintData)
        ? complaintData?.accused_license_number
        : "",
    };

    const appeal_id = courtAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsRejectAppealOpen(false);
      showToast(t("successfullyCreated"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>💼</span>
        {complaintData && Array.isArray(complaintData)
          ? ""
          : complaintData?.is_on_advocate_complaint
            ? t("advocate")
            : t("paralegal")}{" "}
        {t("appealDetail")}
      </h1>

      {/* Header: Tabs */}
      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        <div className="text-right">
          {activeTab === tabs[1] && (
            <div className="flex gap-4">
              {canSendAppealToRegistrar &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.APPROVED && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToRegistrarModal(true)}
                  >
                    {t("sendToRegistrar")}
                  </button>
                )}
              {/* {console.log(councilAppealData)} */}
              {canSendAppealToCouncil &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                councilAppealData[0]?.registration_number && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToCouncilModal(true)}
                  >
                    {t("sendToCouncil")}
                  </button>
                )}

              {canCreateAppealSummon &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !appealSummonData && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsRejectAppealOpen(true)}
                  >
                    {t("rejectAppeal")}
                  </button>
                )}

              {canCreateAppealSummon &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !appealSummonData && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealSummonOpen(true)}
                  >
                    {t("createAppealSummon")}
                  </button>
                )}
            </div>
          )}
          {activeTab === tabs[2] && (
            <div className="flex gap-4">
              {
                // appealSummonData?.accused_confirmed &&
                appealSummonData?.coordinator_confirmed &&
                  ((canCreateInspectionDailyHearing &&
                    (!appealLitigationData ||
                      (appealLitigationData &&
                        !appealLitigationData[0]?.is_final_verdict_given))) ||
                    (canCreateCouncilDailyHearing &&
                      (!appealCouncilLitigationData ||
                        (appealCouncilLitigationData &&
                          !appealCouncilLitigationData[0]
                            ?.is_final_verdict_given)))) && (
                    <button
                      className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                      type="submit"
                      onClick={() => setIsDailyHearingOpen(true)}
                    >
                      {canCreateCouncilDailyHearing &&
                      appealCouncilLitigationData?.length === 0
                        ? t("addInitialHearing")
                        : t("addDailyHearing")}
                    </button>
                  )
              }

              {canCreateLitigationDecision &&
                appealLitigationData &&
                appealLitigationData[0]?.is_final_verdict_given &&
                !appealLitigationData[0]?.council_decision_summary &&
                !appealLitigationData[0]?.council_decision && (
                  // councilLitigationData &&
                  // councilLitigationData[0]?.is_final_verdict_given &&
                  // (councilLitigationData[0]?.council_decision_summary ||
                  //   councilLitigationData[0]?.council_decision) &&
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsLitigationDecisionOpen(true)}
                  >
                    {t("addAppealLitigationDecision")}
                  </button>
                )}

              {canCreateCouncilLitigationDecision &&
                appealCouncilLitigationData &&
                appealCouncilLitigationData[0]?.is_final_verdict_given &&
                !appealCouncilLitigationData[0]?.council_decision_summary &&
                !appealCouncilLitigationData[0]?.council_decision && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                  >
                    {t("addCouncilOfficeDecision")}
                  </button>
                )}

              {canAppealToCourt &&
                (courtAppealData?.length ?? 0) === 0 &&
                appealLitigationData &&
                // appealLitigationData[0]
                //   ?.prosecutor_opinion_on_decision_appeal ==
                //   PROSECUTOR_APPEAL_OPINION.APPEAL &&
                appealCouncilLitigationData &&
                appealCouncilLitigationData[0]?.is_final_verdict_given &&
                (appealCouncilLitigationData[0]?.council_decision_summary ||
                  appealCouncilLitigationData[0]?.council_decision) && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealCourtOpen(true)}
                  >
                    {t("appealToCourt")}
                  </button>
                )}

              {/* Inspection Litigation Termination */}
              {/* {canTerminateInspectionLitigation &&
                          appealLitigationData &&
                          !appealLitigationData[0]?.termination_reason &&
                          appealLitigationData[0]?.is_final_verdict_given && (
                            <button
                              className="bg-red-900 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                              type="submit"
                              onClick={() => setIsTerminateOpen(true)}
                            >
                              Terminate
                            </button>
                          )} */}

              {/* Council Litigation Termination */}
              {/* {canTerminateCouncilLitigation &&
                          appealCouncilLitigationData &&
                          !appealCouncilLitigationData[0]?.termination_reason &&
                          appealCouncilLitigationData[0]?.is_final_verdict_given && (
                            <button
                              className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                              type="submit"
                              onClick={() => setIsTerminateOpen(true)}
                            >
                              Terminate
                            </button>
                          )} */}
            </div>
          )}
          {activeTab === tabs[3] && (
            <div className="flex gap-4">
              {canSendAppealToRegistrar &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.APPROVED && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToRegistrarModal(true)}
                  >
                    {t("sendToRegistrar")}
                  </button>
                )}

              {/* {canSendAppealToCouncil &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                courtAppealData[0]?.registration_number && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToCouncilModal(true)}
                  >
                    Send to Council
                  </button>
                )} */}

              {/* {canCreateAppealSummon &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonData && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsRejectAppealOpen(true)}
                  >
                    Reject Appeal
                  </button>
                )} */}

              {/* {canCreateAppealSummon &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonData && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealSummonOpen(true)}
                  >
                    Create Appeal Summon
                  </button>
                )} */}
            </div>
          )}
          {activeTab === tabs[4] && (
            <div className="flex gap-4">
              {
                // appealSummonData?.accused_confirmed &&
                // courtAppealSummonData?.coordinator_confirmed &&
                canCreateInspectionDailyHearing &&
                  courtAppealData &&
                  courtAppealData?.length > 0 &&
                  courtAppealData[0]?.appeal_status ===
                    APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                  courtAppealData[0]?.registration_number &&
                  (!courtAppealLitigationData ||
                    (courtAppealLitigationData &&
                      !courtAppealLitigationData[0]
                        ?.is_final_verdict_given)) && (
                    <button
                      className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                      type="submit"
                      onClick={() => setIsDailyHearingOpen(true)}
                    >
                      {t("addDailyHearing")}
                    </button>
                  )
              }

              {canCreateLitigationDecision &&
                courtAppealLitigationData &&
                courtAppealLitigationData[0]?.is_final_verdict_given &&
                !courtAppealLitigationData[0]?.council_decision_summary &&
                !courtAppealLitigationData[0]?.council_decision && (
                  // councilLitigationData &&
                  // councilLitigationData[0]?.is_final_verdict_given &&
                  // (councilLitigationData[0]?.council_decision_summary ||
                  //   councilLitigationData[0]?.council_decision) &&
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsLitigationDecisionOpen(true)}
                  >
                    {t("addAppealLitigationDecision")}
                  </button>
                )}

              {/* Inspection Litigation Termination */}
              {/* {canTerminateInspectionLitigation &&
                          courtAppealLitigationData &&
                          !courtAppealLitigationData[0]?.termination_reason &&
                          courtAppealLitigationData[0]?.is_final_verdict_given && (
                            <button
                              className="bg-red-900 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                              type="submit"
                              onClick={() => setIsTerminateOpen(true)}
                            >
                              Terminate
                            </button>
                          )} */}
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Detail Info */}
        {activeTab === tabs[0] && (
          <div className="lg:col-span-2 space-y-4">
            {investigationData &&
              complaintData &&
              !Array.isArray(complaintData) &&
              (canViewChargeDoc ||
                investigationData?.status ===
                  INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL) && (
                <ChargeDocumentCard
                  investigationData={investigationData}
                  complaintData={complaintData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail &&
              complaintData &&
              !Array.isArray(complaintData) &&
              complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                <DecisionCard
                  complaintData={complaintData}
                  investigationData={investigationData}
                  allInvestigationData={allInvestigationData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail && (
              <ComplaintDetailInfoCard
                complaintData={complaintData}
                onComplaintsRefresh={loadComplaints}
              />
            )}
          </div>
        )}

        {/*Council Appeal */}
        {activeTab === tabs[1] && (
          <div className="lg:col-span-2 space-y-4">
            {appealSummonData &&
              complaintData &&
              !Array.isArray(complaintData) && (
                <AppealSummonCard
                  summonData={appealSummonData}
                  compliantData={complaintData}
                  appealLitigationData={appealLitigationData}
                  onSummonRefresh={loadSummon}
                />
              )}

            {complaintData &&
              !Array.isArray(complaintData) &&
              councilAppealData &&
              councilAppealData?.length > 0 &&
              councilAppealData?.length > 0 && (
                <AppealCard
                  complaintData={complaintData}
                  appealData={councilAppealData}
                  onAppealRefresh={loadAppeal}
                />
              )}
          </div>
        )}

        {/* Council Litigation */}
        {activeTab === tabs[2] && (
          <div className="lg:col-span-2 space-y-4">
            {appealCouncilLitigationData &&
              appealCouncilLitigationData?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={appealCouncilLitigationData}
                  onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                />
              )}

            {appealLitigationData && appealLitigationData?.length > 0 && (
              <AppealLitigationCard
                litigationData={appealLitigationData}
                councilLitigationData={appealCouncilLitigationData || []}
                onLitigationRefresh={loadAppealLitigation}
              />
            )}
          </div>
        )}
        {/* Appeal To Court */}
        {activeTab === tabs[3] && (
          <div className="lg:col-span-2 space-y-4">
            {courtAppealSummonData &&
              complaintData &&
              !Array.isArray(complaintData) && (
                <AppealSummonCard
                  summonData={courtAppealSummonData}
                  compliantData={complaintData}
                  appealLitigationData={appealLitigationData}
                  onSummonRefresh={loadSummon}
                />
              )}

            {canViewCourtAppeal &&
              complaintData &&
              !Array.isArray(complaintData) &&
              courtAppealData &&
              courtAppealData?.length > 0 &&
              courtAppealData?.length > 0 && (
                <AppealCard
                  complaintData={complaintData}
                  appealData={courtAppealData}
                  onAppealRefresh={loadAppeal}
                />
              )}
          </div>
        )}

        {/* Court Litigation */}
        {activeTab === tabs[4] && (
          <div className="lg:col-span-2 space-y-4">
            {courtAppealCouncilLitigationData &&
              courtAppealCouncilLitigationData?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={courtAppealCouncilLitigationData}
                  onCouncilLitigationRefresh={loadCourtAppealCouncilLitigation}
                />
              )}

            {courtAppealLitigationData &&
              courtAppealLitigationData?.length > 0 && (
                <AppealLitigationCard
                  fromCourt={true}
                  litigationData={courtAppealLitigationData}
                  councilLitigationData={courtAppealCouncilLitigationData || []}
                  onLitigationRefresh={loadCourtAppealLitigation}
                />
              )}
          </div>
        )}

        {/* Sidebar */}
        <div className="space-y-4">
          {canViewSummonConfirmation &&
            ((activeTab === tabs[1] && appealSummonData && (
              <SummonConfirmationStatus summonData={appealSummonData} />
            )) ||
              (activeTab === tabs[3] && courtAppealSummonData && (
                <SummonConfirmationStatus summonData={courtAppealSummonData} />
              )))}

          {canViewCompliantDetail && (
            <>
              {/* Evidence List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("evidence")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("evidence")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.evidence ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.evidence
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListEvidenceCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Reporter List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("reporter")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("reporter")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.reporter ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.reporter
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListReporterCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Victim List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("victim")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("victim")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.victim ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.victim
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListVictimCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Witness List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("witness")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("witness")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.witness ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.witness
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListWitnessCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}

      {complaintData && !Array.isArray(complaintData) && (
        <>
          {((activeTab === tabs[3] && courtAppealData && courtAppealData[0]) ||
            (activeTab !== tabs[3] &&
              councilAppealData &&
              councilAppealData[0])) && (
            <AddAppealSummonModal
              isOpen={isAppealSummonOpen}
              setIsOpen={setIsAppealSummonOpen}
              appealData={
                activeTab === tabs[3]
                  ? courtAppealData![0]
                  : councilAppealData![0]
              }
              complaintData={complaintData}
              onAppealSummonRefresh={loadAppeal}
            />
          )}
        </>
      )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        ((activeTab === tabs[2] && appealSummonData) ||
          (activeTab === tabs[4] && courtAppealData)) &&
        !Array.isArray(appealSummonData) && (
          <AddAppealDailyHearingModal
            isOpen={isDailyHearingOpen}
            setIsOpen={setIsDailyHearingOpen}
            summonData={
              activeTab === tabs[4] ? courtAppealSummonData! : appealSummonData!
            }
            appealData={
              activeTab === tabs[4]
                ? courtAppealData![0]
                : councilAppealData![0]
            }
            complaintData={complaintData}
            onLitigationRefresh={
              activeTab === tabs[4]
                ? loadCourtAppealLitigation
                : loadAppealLitigation
            }
            onCouncilLitigationRefresh={
              activeTab === tabs[4]
                ? loadCourtAppealCouncilLitigation
                : loadAppealCouncilLitigation
            }
          />
        )}

      {((activeTab === tabs[2] &&
        appealLitigationData &&
        appealLitigationData[0]) ||
        (activeTab === tabs[4] &&
          courtAppealLitigationData &&
          courtAppealLitigationData[0])) &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealLitigationDecisionModal
            isOpen={isLitigationDecisionOpen}
            setIsOpen={setIsLitigationDecisionOpen}
            fromCourt={activeTab === tabs[4] ? true : false}
            litigationData={
              activeTab === tabs[4]
                ? courtAppealLitigationData![0]
                : appealLitigationData![0]
            }
            complaintData={complaintData}
            onRefresh={
              activeTab === tabs[4]
                ? loadCourtAppealLitigation
                : loadAppealLitigation
            }
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={appealCouncilLitigationData[0]}
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealToCourtModal
            isOpen={isAppealCourtOpen}
            setIsOpen={setIsAppealCourtOpen}
            complaintData={complaintData}
            onCompliantRefresh={loadComplaints}
            defaultAppealType="inspection_to_court"
          />
        )}

      <ConfirmationModal
        isOpen={isSendToRegistrarModal}
        onCancel={() => setIsSendToRegistrarModal(false)}
        onConfirm={
          activeTab === tabs[1]
            ? handleSendToRegistrarConfirm
            : handleCourtSendToRegistrarConfirm
        }
        isLoading={isSubmitLoading}
      />

      <ConfirmationModal
        isOpen={isSendToCouncilModal}
        onCancel={() => setIsSendToCouncilModal(false)}
        onConfirm={
          activeTab === tabs[1]
            ? handleSendToCouncilConfirm
            : handleCourtSendToCouncilConfirm
        }
        isLoading={isSubmitLoading}
      />

      <ConfirmationModal
        isOpen={isRejectAppealOpen}
        onCancel={() => setIsRejectAppealOpen(false)}
        onConfirm={
          activeTab === tabs[1] ? handleRejectAppeal : handleCourtRejectAppeal
        }
        isLoading={isSubmitLoading}
      />
    </div>
  );
}
